export enum GameVersion {
  WSM = 'wsm',
  SSM = 'ssm',
}
